export default __webpack_public_path__ + "static/media/codeofconduct.19fbf4ef.svg";